﻿//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import ArrayStore from 'devextreme/data/array_store'
import 'devextreme/ui/accordion'
import 'devextreme/ui/tabs'
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'

//#endregion

//#region Service Imports

import { DetailsResult } from '../../services/system'

//#endregion

import { i18n } from './i18n/common.i18n'
import { TabsData } from './common.interfaces'
import { OperatorLayoutSettings } from '../../helpers/operator-layout-settings'
import { EventsNames } from '../../helpers/events-names'
import { Api, LocalDictionaryFactory } from '../api/api.module'
import { LoggerService } from './common.logger.service'
import { ColumnModel, FieldModel, EntityModel } from '../api/api.models'
import { CommonHelper } from '../../helpers/common-helper'
import { DetailsPopupOptions, DetailsOptions } from './details-popup/details-popup.directive'
import { GridTypes } from './grid/grid.controller'
import { Enums } from '../../models/common/enums'
import { IUserSession } from '../../helpers/user-session'
import { IOpObject, IOpData } from '../../models/util/interfaces'
import { OpDataTypeInGroup } from '../../models/core/op-data-type-in-group'
import { TypeHelper } from '../../helpers/type-helper';
import { TemplateHelper, ConfigHelper, LocalizationHelper } from '../../helpers'
import { TreeListOptions } from "./tree-list/tree-list.controller";
import { IMRBaseControlDirectiveController } from './base'
import { OpViewColumn } from '../../models/core'

export interface DetailsAccordionSection {
    canEdit: boolean
    name: string
    showStatus: boolean
    title: string
    visible: boolean

    canConfigure?: boolean
    canSendLocationConfigurationProfile?: boolean
    selected?: boolean
    showInTab?: string

    configureMethod?: () => void
    editMethod?: () => void
    onCollapsed?: () => void
    onExpanded?: () => void
    onHidden?: () => void
    sendLocationConfigurationProfile?: () => void
    status?: () => string
}

export class DetailsAccordion {
    // Consts
    private static get LOG_STRING(): string { return '[SIMAX.Common.CommonDetails] - %s' }
    // Consts End

    private options: DevExpress.ui.dxAccordion
    public instance: DevExpress.ui.dxAccordion
    private selectedItems: any[] = []

    private accordionSettingForHidden: string
    private height: string = '0'
    private updateItemsTimeout

    public needRefresh: (() => void) = null
    public visible: boolean
    public hideContent: boolean = false

    public class: string
    private visibleItemsLength: number

    private error = false

    constructor(private $scope, private $timeout: ng.ITimeoutService, public accordionId: string, position: number, public items: DetailsAccordionSection[], private multiple: boolean = false, onInitialized: ((component: DevExpress.ui.dxAccordion) => void) = null) {
        var accordionSetting = accordionId + position
        var selectedIndexes = OperatorLayoutSettings.getSetting(accordionSetting, [0])
        if (!selectedIndexes.indexOf) selectedIndexes = [0]
        this.accordionSettingForHidden = accordionSetting + 'hidden'
        var hiddenItems: string[] = OperatorLayoutSettings.getSetting(this.accordionSettingForHidden, [])
        var visibleItems = items.filter((item, index) => {
            if (hiddenItems.indexOf(item.name) == -1) {
                item.visible = true
                if (selectedIndexes.indexOf(index) > -1) {
                    item.selected = true
                    this.selectedItems.push(item)
                }
                return true
            }
            item.visible = false
            if (item.onHidden) item.onHidden()
            return false
        })

        if (visibleItems.length == 1) {
            visibleItems[0].selected = true
        }

        //https://app.asana.com/0/497700357781105/496202367609326/f
        //else if (visibleItems.length == 0 && items.length == 1) {
        //    visibleItems = items
        //    visibleItems[0].selected = true
        //    visibleItems[0].visible = true
        //}

        if (visibleItems.length > 0 && visibleItems.filter(i => i.selected).length == 0) {
            visibleItems[0].selected = true
            selectedIndexes = [0]
        }

        this.options = null
        this.$timeout(() => {
            this.options = <any>{
                dataSource: visibleItems,
                noDataText: '',
                selectedItems: this.selectedItems,
                itemTemplate: 'panel',
                multiple: multiple,
                height: () => {
                    return angular.element(window).width() >= 768 ? '100%' : (400 * this.items.filter(item => item.visible).length) + 'px'
                },
                animationDuration: 300,
                onSelectionChanged: e => {
                    var addedItems: DetailsAccordionSection[] = e.addedItems
                    addedItems.forEach(item => {
                        item.selected = true

                        if (item.onExpanded) {
                            item.onExpanded()
                        }
                    })
                    var removedItems: DetailsAccordionSection[] = e.removedItems
                    removedItems.forEach(item => {
                        if (item) {
                            item.selected = false
                        }

                        if (item.onCollapsed) {
                            item.onCollapsed()
                        }
                    })

                    var selectedIndex = this.items.map((item, index) => { return { selected: item.selected, index: index } }).filter(i => i.selected).map(i => i.index)
                    this.selectedItems = this.items.filter(i => i.selected)
                    OperatorLayoutSettings.setSetting(accordionSetting, selectedIndex)

                    this.hideContent = true
                    $timeout(() => {
                        this.hideContent = false
                    }, 500)
                },
                onInitialized: e => {
                    this.instance = e.component
                    if (onInitialized) onInitialized(e.component)
                    this.selectedItems = this.items.filter(i => i.selected)
                    this.instance.option('selectedItems', this.selectedItems)
                    this.hideContent = true
                    this.$timeout(() => {
                        try {
                            this.instance.repaint()
                        } catch (error) {
                            console.warn(DetailsAccordion.LOG_STRING, 'Error during repaint() accordion.')
                        }
                        this.hideContent = false
                    })
                }
            }
        })

        this.visible = visibleItems.length > 0

        this.class = visibleItems.length <= 1 ? "single" : "multiple"
    }

    private hidePromise: JQueryPromise<void>
    private hideSync(name: string) {
        var hideDeferred = $.Deferred<void>()
        if (!this.hidePromise) {
            this.hidePromise = hideDeferred.promise().then(() => {
                this.hidePromise = null
            })
        }

        var itemPromise: JQueryPromise<void> = null
        var items = this.items.filter((item, index) => {
            if (name == item.name) {
                if (this.multiple) {
                    if (item.selected) {
                        this.items.every((item2, i) => {
                            if (item2.visible && !item2.selected) {
                                itemPromise = this.instance.expandItem(i).then(() => {
                                    item2.selected = true
                                }) as JQueryPromise<void>
                                return false
                            }
                            return true
                        })

                        var collapse = () => {
                            if (this.items.filter(i => i.visible).length == 1) {
                                this.hideItem(item)
                                return null
                            } else {
                                return this.instance.collapseItem(index).then(() => {
                                    this.hideItem(item)
                                })
                            }
                        }

                        if (itemPromise) {
                            itemPromise = itemPromise.then(() => {
                                return collapse()
                            })
                        } else {
                            itemPromise = collapse() as JQueryPromise<void>
                        }

                        return false
                    }
                }
                this.hideItem(item)
            }
            return item.visible
        })

        var up = () => {
            if (items.length == 0) {
                if (this.visible && this.needRefresh) this.needRefresh()
                this.visible = false
                this.options['dataSource'] = []
                this.instance.option({ 'dataSource': [] })
                this.items.forEach((v, i) => {
                    if (i == 0) {
                        this.instance.expandItem(i)
                    } else {
                        this.instance.collapseItem(i)
                    }
                })
                this.save()
            }
            else this.updateItems(items)
            hideDeferred.resolve()
        }

        if (itemPromise) {
            itemPromise.then(() => {
                up()
            })
        } else {
            up()
        }

        this.visibleItemsLength = this.items.filter(item => item.visible).length
        if (this.visibleItemsLength < 2) {
            $("header:before").addClass("display:none");
        }
    }

    public hide(name: string) {
        if (this.hidePromise) {
            this.hidePromise.then(() => {
                this.hideSync(name)
            })
        } else {
            this.hideSync(name)
        }
    }

    private hideItem(item: DetailsAccordionSection) {
        if (item.visible && item.onHidden) {
            item.onHidden()
        }
        item.visible = false
        item.selected = false
    }

    public show(name: string) {
        var items = this.items.filter(item => {
            if (name == item.name) {
                item.visible = true
                if (this.items.filter(i => i.selected).length == 0) {
                    item.selected = true
                }
            }
            return item.visible
        })
        if (!this.visible && this.needRefresh) this.needRefresh()
        this.visible = true
        this.updateItems(items)
    }

    public update(names: string[]) {
        this.items.forEach(item => {
            if (names.indexOf(item.name) > -1) {
                if (!item.visible) this.show(item.name)
            } else {
                if (item.visible) this.hide(item.name)
            }
        })
    }

    private itemsNew(items: DetailsAccordionSection[]) {
        var lastItems: DetailsAccordionSection[] = this.options['dataSource']
        if (lastItems.length != items.length) return true
        return !items.every(item => {
            return !lastItems.every(lastItem => !(item.name == lastItem.name))
        })
    }

    private updateItems(items: DetailsAccordionSection[]) {
        if (this.updateItemsTimeout) clearTimeout(this.updateItemsTimeout)
        this.updateItemsTimeout = setTimeout(() => {
            if (this.itemsNew(items)) {
                this.options['dataSource'] = items
                var instance = this.instance
                if (instance) {
                    var selectedIndex = this.instance.option('selectedIndex')
                    if (selectedIndex >= items.length) selectedIndex = items.length - 1
                    else if (selectedIndex <= -1) selectedIndex = 0

                    var selectedItems = this.items.filter(item => {
                        if (item.visible) item.selected = true
                        return item.visible
                    })
                    try {
                        instance.option({
                            'dataSource': items,
                            'selectedItems': selectedItems
                        })
                    } catch (e) {
                        // workaround for dynamic accordions
                        this.error = true
                        this.$timeout(() => {
                            this.error = false
                        })
                    }
                }
                this.save()
            }
            const activeAccordions = $('.dx-accordion-item')
            if (activeAccordions.length == 1 || activeAccordions.length == 2) {
                $('.dx-accordion-item').height('100%')
            }
        }, 200)
    }

    private save() {
        OperatorLayoutSettings.setSetting(this.accordionSettingForHidden, this.items.filter(item => !item.visible).map(item => item.name))
    }
}

export interface DetailsScope extends ng.IScope {
    accordionsEditButtonHint: string
    noDefinedContent: string
    noActiveAccordions: string

    accordionHeight: string

    detailsOpenParams: DetailsOptions

    modelId: number
    itemObjects: any[]
    popupFor: string
    options: DetailsPopupOptions

    visiblePopup: boolean
    popup: DevExpress.ui.dxPopup
    popupTitle: string

    editClick(e)
    configClick(e)
    sendLocationConfigurationProfileClick(e)
    detailsPopupId: number
    i18n: any
    tabs: TabsData
    showTabs: boolean
    showMobileCloseButton: boolean

    accordions: DetailsAccordion[]
    anyAccordionVisible: () => void
    accordionsClosing: () => boolean

    requestsStates: any
    closeAccordionButtonOptions(accordion: DetailsAccordion, name: string)

    isLoading: boolean

    accordionsButtonVisible: boolean

    level: number
}

export abstract class Details<T extends DetailsScope> extends IMRBaseControlDirectiveController {

    //#region Members

    private _moduleName: Enums.SimaxModuleName
    private detailResultStatus: DetailsResult.Status
    private detailsResultCallback: (result: DetailsResult) => void;

    //#endregion

    private tabsPanel: DevExpress.ui.dxTabPanel
    private tabs: { template: string, name: string }[]
    protected accordionsNameToShow: string
    protected refreshAccordions: (isMobile: boolean) => any

    constructor(
        protected $scope: T,
        protected $timeout: ng.ITimeoutService,
        protected $q: ng.IQService,
        protected logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory,
        private tabsId: string,
        protected userSession: IUserSession,
        protected referenceType: Enums.ReferenceType,
        moduleName: Enums.SimaxModuleName = null
    ) {
        super()

        this._moduleName = moduleName;

        $scope.accordionsEditButtonHint = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit)
        $scope.noDefinedContent = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoDefinedContent)
        $scope.noActiveAccordions = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoActiveAccordions)

        $scope.options = <DetailsPopupOptions>{}
        $scope.visiblePopup = false
        $scope.closeAccordionButtonOptions = (accordion: DetailsAccordion, name: string) => {
            return {
                template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, userSession),
                onClick: (e) => {
                    e.event.stopPropagation()

                    this.hideAccordion(name, accordion)
                    this.checkAccordionClass(accordion)
                },
                hint: i18n('Popup', 'Close')
            }
        }
        $scope.detailsPopupId = new Date().getTime()
        $scope.i18n = i18n
        $scope.tabs = <TabsData>{}
        $scope.accordions = []

        $scope.anyAccordionVisible = () => {
            return $scope.accordions.filter(accordion => accordion.visible).length != 0
        }

        $scope.tabs.selectedTab = this.getSelectedTabFromConfig(tabsId)
        if (!$scope.tabs.selectedTab) {
            $scope.tabs.selectedTab = 0
        }

        // accordion edit button
        $scope.editClick = e => {
            if (e.model.section.editMethod)
                e.model.section.editMethod()
            e.event.stopPropagation()
        }

        // accordion configure button
        $scope.configClick = e => {
            if (e.model.section.configureMethod)
                e.model.section.configureMethod()
            e.event.stopPropagation()
        }

        $scope.sendLocationConfigurationProfileClick = e => {
            if (e.model.section.sendLocationConfigurationProfile)
                e.model.section.sendLocationConfigurationProfile()
            e.event.stopPropagation()
        }

        $scope.$watch('modelId', val => {
            $scope.options.modelId = val
        })

        $scope.$watchCollection('itemObjects', (val: any[]) => {
            $scope.options.items = val
        })

        $scope.$watchCollection('detailsOpenParams', (val: DetailsOptions) => {
            if (val) {
                let entityId = val.referenceObjectId

                if (!entityId && val.referenceObject) {
                    entityId = TypeHelper.getId(val.referenceObject)
                }

                $scope.modelId = entityId
                $scope.detailsOpenParams = val

                if (val.activeTab != null) {
                    this.setSelectedTabByName(val.activeTab)
                }
            }
        })

        $scope.$watch('popupTitle', (val: string) => {
            $scope.options.contentTitle = val
        })

        $scope.$watch('visiblePopup', (val: boolean) => {
            $scope.options.visiblePopup = val
        })


        this.refreshAccordions = _.debounce((isMobile) => {
            $scope.accordions = []
            $timeout(() => {
                var accordions = this.getAccordions()
                if (isMobile && accordions.length > 0) {
                    var items = []
                    accordions.forEach(accordion => {
                        items.push(...accordion.items)
                    })

                    var accordion = new DetailsAccordion($scope, $timeout, accordions[0].accordionId + 'mobile', 0, items, true)
                    accordions = [accordion]
                }

                this.$scope.accordions = accordions
                this.$scope.accordions = this.filterAccordionForTab(accordions, this.$scope.tabs.selectedTabName)
            })
        }, 100)

        $scope.$watch(() => {
            return angular.element(window).width() < 960
        }, (isMobile) => {
            this.refreshAccordions(isMobile)
            if (isMobile) $scope.showMobileCloseButton = true
            else $scope.showMobileCloseButton = false
        })

        $scope.$on(EventsNames.CLOSE_DETAILS_POPUP, () => {
            this.hidePopup()
        })

        $scope.accordionsClosing = () => {
            if ($scope.accordions.length > 1) {
                return true
            }
            else {
                if ($scope.accordions.length == 1) {
                    if ($scope.accordions[0].items && $scope.accordions[0].items.length > 1) {
                        return true
                    }
                    else {
                        return false
                    }
                }
            }
            return false
        }

        if (moduleName != null) {
            this._setEvents();
        }
    }

    getAccordionData() {
        return [].concat.apply([], this.$scope.accordions.map(accordion => accordion.items.map(item => { return { name: item.title, value: item.name } })))
    }

    getAccordionSelection() {
        return [].concat.apply([], this.$scope.accordions.map(accordion => accordion.items.filter(item => item.visible).map(item => item.name)))
    }

    updateAccordions(names: any[]) {
        this.$scope.accordions.forEach(accordion => {
            accordion.update(names)
        })

        this.checkAccordionClass()
    }

    getDetailedParamsGridOptions(api: Api, detailsFields: FieldModel[], displayFields: ColumnModel[], gridName: string, gridNameForSave: string, showLegend: boolean) {
        var items = []
        var time = +new Date()
        Details.filterFields(detailsFields, displayFields).forEach((field, index) => {
            items.push({
                id: field.id,
                description: field.caption,
                index: field.index,
                value: field.value,
                typeId: field.typeId,
                rowColor: field.rowColor,
                referenceTypeId: field.referenceTypeId,
                idDataType: field.idDataType,
                unitName: field.unitName,
                rowId: time++,
                parentId: 0
            })
        })
        var treeListItems = []
        var groupedData = _.groupBy(items, 'idDataType')
        if (groupedData) {
            for (var i in groupedData) {
                var groupedRows = groupedData[i]
                if (groupedRows.length > 1) {
                    treeListItems.push({
                        description: groupedRows[0].description,
                        index: groupedRows.map(row => row.index).join(';'),
                        rowId: groupedRows[0].idDataType,
                        rows: groupedRows,
                        typeId: groupedRows[0].typeId,
                        unitName: groupedData[i][0].unitName
                    })
                    groupedRows.forEach(row => {
                        row.parentId = groupedRows[0].idDataType
                    })
                }
            }
        }
        treeListItems.push(...items)

        var cacheReferenceValues: { referenceTypeId: number, idDataType: number, value: any, promise: any }[] = []
        var getReferenceValue = (referenceTypeId: number, idDataType: number, value: any) => {
            var referencesFromCache = cacheReferenceValues.filter(v => v.referenceTypeId == referenceTypeId && v.idDataType == idDataType && v.value == value)
            if (referencesFromCache.length > 0) {
                return referencesFromCache[0].promise
            } else {
                var defer = this.$q.defer<any>()
                var referenceSettings = CommonHelper.getReferenceSettings(this.userSession.getDataProvider(), referenceTypeId, idDataType, this.localDictionary)
                if (referenceSettings.isSelectGrid) {
                    if (value) {
                        var request = new EntityModel()
                        request.referenceId = referenceTypeId
                        request.id = value
                        api.app.getReferenceObject(request).then(result => {
                            var value = result ? result['name'] : null
                            defer.resolve(value)
                        })
                    }
                } else if (referenceTypeId && idDataType && value) {
                    this.localDictionary.getReferenceValueCaption(referenceTypeId, idDataType, value).then(val => {
                        defer.resolve(val)
                    })
                } else {
                    defer.resolve(value)
                }
                var cacheReferenceValue = {
                    referenceTypeId,
                    idDataType,
                    value,
                    promise: defer.promise
                }
                cacheReferenceValues.push(cacheReferenceValue)
                return cacheReferenceValue.promise
            }
        }

        var options = {
            name: gridName,
            idReferenceType: Enums.ReferenceType.None,
            type: GridTypes.NO_SEARCH_BAR_SMALL,
            keyExpr: 'rowId',
            parentIdExpr: 'parentId',
            buttonsOptions: {
                enabled: showLegend,
            },
            addCustomFilters: true,
            localStorageVarForSavedEntity: gridNameForSave,
            dictionariesForSave: displayFields,
            columns: [
                {
                    dataField: "description",
                    caption: i18n("Common", "Description")
                },
                {
                    dataField: "index",
                    caption: i18n("Common", "Index")
                },
                {
                    dataField: "value",
                    caption: i18n("Common", "Value"),
                    dataType: "string"
                },
                {
                    dataField: "unitName",
                    caption: i18n("Common", "Unit"),
                    dataType: "string"
                }
            ],
            dataSource: new ArrayStore({
                key: 'rowId',
                data: treeListItems
            }),
            onCellPrepared: e => {
                if (e.rowType === "data" && e.column.dataField == "value") {
                    if (e.data.referenceTypeId && e.data.idDataType && e.data.value) {
                        getReferenceValue(e.data.referenceTypeId, e.data.idDataType, e.data.value).then(val => {
                            e.cellElement.html(val)
                        })
                    } else if (e.data.rows) {
                        this.$q.all(e.data.rows.map(row => {
                            if (row.referenceTypeId)
                                return getReferenceValue(row.referenceTypeId, row.idDataType, row.value)
                            else
                                return row.value
                        })).then(values => {
                            e.cellElement.html(values.map(val => {
                                return CommonHelper.cellFormatForDifferentValues(
                                    this.userSession,
                                    {
                                        value: val,
                                        typeId: e.data.typeId
                                    }, null, e.data.idDataType)
                            }).join(';'))
                        })
                    } else {
                        e.cellElement.html(CommonHelper.cellFormatForDifferentValues(
                            this.userSession,
                            {
                                value: e.data.value,
                                typeId: e.data.typeId
                            }, null, e.data.idDataType))
                    }
                }
            },
            showDatatypeLegend: true
        }

        if (showLegend) {
            options.showDatatypeLegend = true
        }

        return options as TreeListOptions
    }

    showPopup() {
        this.$scope.visiblePopup = true
        this.$scope.$emit(EventsNames.OPENED_POPUP)
    }

    hidePopup() {
        this.onHidden();

        this.$scope.visiblePopup = false
        this.$scope.$emit(EventsNames.CLOSED_POPUP)
    }

    getSelectedTabName() {
        return this.tabs[this.$scope.tabs.selectedTab] ? this.tabs[this.$scope.tabs.selectedTab].name : ''
    }

    checkSelectedTabs() {
        if (this.accordionsNameToShow && this.$scope.tabs.selectedTabName) {
            this.$scope.accordionsButtonVisible = this.accordionsNameToShow == this.$scope.tabs.selectedTabName
        } else {
            this.$scope.accordionsButtonVisible = false
        }
    }

    configureTabs(tabs: { template: string, name: string }[]) {
        if (this.$scope.tabs.selectedTab >= tabs.length) this.$scope.tabs.selectedTab = tabs.length - 1
        this.tabs = tabs
        this.$scope.tabs.selectedTabName = this.getSelectedTabName()
        this.checkSelectedTabs()
        this.$scope.tabs.visible = this.tabs.length > 1
        this.$scope.tabs.tabsOptions = {
            dataSource: tabs,
            bindingOptions: {
                selectedIndex: 'tabs.selectedTab',
                visible: 'tabs.visible'
            },
            onItemRendered: e => {
                var tabs = e.itemElement
                CommonHelper.setFocusOnTab(tabs)
            },
            onSelectionChanged: (e) => {
                this.$scope.isLoading = true
                this.$timeout(() => {
                    OperatorLayoutSettings.setSetting(this.tabsId, this.$scope.tabs.selectedTab)
                    this.$scope.tabs.selectedTabName = this.getSelectedTabName()
                    //this.checkSelectedTabs()
                    this.$scope.accordions = this.filterAccordionForTab(this.getAccordions(), this.$scope.tabs.selectedTabName)
                    this.$scope.isLoading = false
                    this.$scope.$root.$broadcast(EventsNames.TAB_SELECTION_CHANGE + this.$scope.options.title, this.$scope.tabs.selectedTab, this.$scope.tabs.selectedTabName)


                    if (this.$scope.options.onTabSelected != null) {
                        this.$scope.options.onTabSelected({
                            tabName: this.$scope.tabs.selectedTabName
                        })
                    }
                }, 100)

                e.component.repaint()
                var tabs = e.element[0].children[0].children
                CommonHelper.setFocusOnTab(tabs)

            },
            onInitialized: e => {
                this.tabsPanel = e.component
            }
        }
    }

    updateTabsPanel(tabs: { template: string, name: string }[]) {
        this.tabs = tabs
        if (this.tabsPanel) {
            var lastSelectedItem = this.tabsPanel.option('selectedIndex')
            this.tabsPanel.option('dataSource', tabs)
            this.tabsPanel.repaint()
            this.tabsPanel.option('selectedItem', lastSelectedItem)
        }
    }

    setSelectedTabByName(name: string) {
        for (var i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].name == name) {
                this.$scope.tabs.selectedTab = i
                this.$scope.tabs.selectedTabName = this.tabs[i].name
                return
            }
        }
    }

    filterAccordionForTab(accordions: DetailsAccordion[], tabName: string) {
        var result: DetailsAccordion[] = []
        accordions.forEach(acc => {
            var tmp = acc
            var items = []

            acc.items.forEach(item => {
                if (!item.showInTab) {
                    item.showInTab = 'common'
                }
                if (item.showInTab == tabName) {
                    items.push(item)
                }
            })

            if (items.length > 0) {
                tmp.items = items
                result.push(tmp)
                this.$scope.accordionsButtonVisible = true
            }
        })
        return result
    }

    private hideAccordion(accordionItemName: string, accordion: DetailsAccordion) {
        if (accordion != null) {
            accordion.hide(accordionItemName)
        }
    }

    private checkAccordionClass(accordion: DetailsAccordion = null) {
        if (accordion != null) {
            if (accordion != null) {
                if (accordion.items.filter(item => item.visible).length > 1) {
                    accordion.class = "multiple"
                }
                else {
                    accordion.class = "single"
                }
            }
        }
        else {
            for (let i = 0; i < this.$scope.accordions.length; i++) {
                const existingAccordion: DetailsAccordion = this.$scope.accordions[i]

                if (existingAccordion != null) {
                    if (existingAccordion.items.filter(item => item.visible).length > 1) {
                        existingAccordion.class = "multiple"
                    }
                    else {
                        existingAccordion.class = "single"
                    }
                }
            }
        }
    }

    showAccordion($scope: DetailsScope, name: string, column: number) {
        var detailsAccordion = this.$scope.accordions[column]
        if (detailsAccordion) detailsAccordion.show(name)
    }

    getSelectedTabFromConfig(tabName: string) {
        return OperatorLayoutSettings.getSetting(tabName, 0)
    }

    updateGridEntities(gridName: string) {
        if (this.$scope[gridName] && this.$scope[gridName].grid) {
            this.$scope[gridName].showGrid = false
            var store = this.$scope[gridName].grid.option("dataSource").store()
            store.clear()
            this.$scope['common'][gridName].forEach(element => {
                store.insert(element)
            })
            this.$scope[gridName].grid.refresh()

            this.$scope[gridName].showGrid = true
        }
    }

    createEventEditForGridEntities(eventName: string, gridName: string) {
        this.$scope.$on(eventName, (...args: any[]) => {
            this.updateGridEntities(gridName)
        })
    }

    static getAllIndexes(arr, val) {
        var indexes = [], i = -1;
        while ((i = arr.indexOf(val, i + 1)) != -1) {
            indexes.push(i);
        }
        return indexes;
    }

    static filterDynamicValues(object: IOpObject, displayField: OpDataTypeInGroup[], indexNbr: number = null, hiddenColumns: OpViewColumn[] = []): FieldModel[] {
        let result: FieldModel[] = []

        if (object != null) {
            _.forEach(displayField, (displayField: OpDataTypeInGroup) => {
                const dynamicValues = _.filter(object.dynamicValues, dynamicValue => {
                    const keyParts = dynamicValue.Key.split('_')

                    return Number(keyParts[1]) === displayField.idDataType
                })

                const idDataTypesInDv: number[] = _.map(dynamicValues, dynamicValue => {
                    const keyParts = dynamicValue.Key.split('_')

                    return Number(keyParts[1])
                })

                let dynamivValuesFromDataList: any[] = [];

                if (object.dataList != null) {
                    dynamivValuesFromDataList = object.dataList
                        .toArray()
                        .filter(value => value.idDataType === displayField.idDataType && !_.contains(idDataTypesInDv, value.idDataType))
                        .map(value => {
                            return {
                                Key: `_${value.idDataType}_${value.indexNBR}`,
                                Value: value.value
                            }
                        })
                }

                _.forEach([...dynamicValues, ...dynamivValuesFromDataList], (dynamicValue: { Key: string, Value: any }) => {
                    const hiddenColumn: OpViewColumn = _.find(hiddenColumns, (viewColumn: OpViewColumn) => viewColumn.name.toLowerCase() === dynamicValue.Key.toLowerCase() && viewColumn.isHidden === true)
                    if (hiddenColumn == null) {
                        const field: FieldModel = new FieldModel()
                        const keyParts = dynamicValue.Key.split('_')
                        const indexNbr = Number(keyParts[2])

                        field.caption = displayField.toString()
                        field.format = <any>displayField.dataType.dataTypeFormat
                        field.idDataType = displayField.idDataType
                        field.isEditable = displayField.dataType.isEditable
                        field.name = displayField.idDataType + ''
                        field.referenceTypeId = displayField.dataType.idReferenceType
                        field.typeId = displayField.dataType.idDataTypeClass
                        field.type = displayField.dataType.dataTypeClass.name
                        field.unitName = displayField.dataType.unit ? displayField.dataType.unit.toString() : ''
                        field['orderNbr'] = displayField.orderNBR

                        field.value = dynamicValue.Value
                        field.index = _.isFinite(indexNbr) ? indexNbr : 0

                        if (_.isFinite(field.value)) {
                            field.valueReferenceId = field.value
                        }

                        if (!_.isFinite(field.value) && field.referenceTypeId != null && object.dataList != null) {
                            const referenceObjectId = object.dataList.getValue(field.idDataType, field.index)

                            if (_.isFinite(referenceObjectId)) {
                                field.valueReferenceId = referenceObjectId
                            }
                        }

                        if (!_.isFinite(field.value)) {
                            field.referenceTypeId = null
                        }

                        result.push(field)
                    }
                })
            })

            result = _.sortBy(result, column => column['orderNbr'])
        }

        return result
    }

    static filterOpObjectFields(object: IOpObject, displayFields: OpDataTypeInGroup[], indexNbr: number = null): FieldModel[] {
        const existingFieldIds: number[] = displayFields.map((field) => field.idDataType)
        let result: FieldModel[] = []
        displayFields.forEach((displayField: OpDataTypeInGroup) => {
            const dataItems: IOpData[] = object.dataList.getDataList(displayField.idDataType, indexNbr)
            dataItems.forEach(data => {
                const field: FieldModel = new FieldModel()
                field.caption = displayField.toString()
                field.format = <any>displayField.dataType.dataTypeFormat
                field.idDataType = displayField.idDataType
                field.isEditable = displayField.dataType.isEditable
                field.name = displayField.idDataType + ''
                field.referenceTypeId = displayField.dataType.idReferenceType
                field.typeId = displayField.dataType.idDataTypeClass
                field.type = displayField.dataType.dataTypeClass.name
                field.unitName = displayField.dataType.unit != null ? displayField.dataType.unit.toString() : ''
                field['orderNbr'] = displayField.orderNBR
                field.valueReferenceId = data.value

                if (dataItems) {
                    field.id = data.idData
                    field.index = data.indexNBR
                    field.rowColor = (<any>data).statusColor //Tylko OpData posiada specyfikację koloru, jeśli to uogólnimy, wtedy należy umieścić
                    field.value = data.value
                }

                result.push(field)
            })
        })

        result = _.sortBy(result, column => column['orderNbr'])

        return result
    }

    static filterFields(fields: FieldModel[], displayFields: ColumnModel[], detailsFields: FieldModel[] = null): FieldModel[] {
        let result: FieldModel[] = []

        if (fields == null || displayFields == null) {
            return result
        }

        const existingFieldIds: number[] = fields.map((field: FieldModel) => field.idDataType)
        const existingDetailsFieldIds: number[] = _.map(detailsFields, (field: FieldModel) => field.idDataType)

        displayFields.forEach((displayField: ColumnModel) => {
            const indexes: any[] = Details.getAllIndexes(existingFieldIds, displayField.id)
            if (indexes.length > 0) {
                indexes.forEach((index: any) => {
                    fields[index].typeId = displayField.type
                    fields[index].caption = displayField.caption
                    fields[index].unitName = displayField.unitName
                    fields[index].isEditable = displayField.isEditable
                    fields[index]['orderNbr'] = displayField['orderNbr']

                    result.push(fields[index])
                })
            } else {
                const indexes: any[] = Details.getAllIndexes(existingDetailsFieldIds, displayField.id)

                if (_.size(indexes) > 0) {
                    indexes.forEach((index: any) => {
                        detailsFields[index].typeId = displayField.type
                        detailsFields[index].caption = displayField.caption
                        detailsFields[index].unitName = displayField.unitName
                        detailsFields[index].isEditable = displayField.isEditable
                        detailsFields[index]['orderNbr'] = displayField['orderNbr']
                        detailsFields[index].referenceTypeId = null

                        result.push(detailsFields[index])
                    })
                }
            }
        })

        result = _.sortBy(result, column => column['orderNbr'])

        return result
    }

    mapUpdateTimeout
    protected mapUpdate() {
        if (this.mapUpdateTimeout) clearTimeout(this.mapUpdateTimeout)
        this.mapUpdateTimeout = setTimeout(() => {
            this.$scope.$broadcast(EventsNames.REFRESH_MAP_SIZE)
        }, 500)
    }

    abstract getTabs()
    abstract getAccordions(): DetailsAccordion[]

    protected isAccordionHidden(accordionName: string): boolean {
        let isHidden: boolean = true

        if (_.size(this.$scope.accordions) > 0) {
            _.forEach(this.$scope.accordions, (acc: DetailsAccordion) => {
                if (_.size(acc.items) > 0) {
                    _.forEach(acc.items, (item: DetailsAccordionSection) => {
                        if (item.name == accordionName) {
                            isHidden = !item.visible
                            return
                        }
                    })
                }
            })
        }

        return isHidden
    }

    protected isAccordionCollapsed(accordionName: string): boolean {
        let collapsed: boolean = true

        if (_.size(this.$scope.accordions) > 0) {
            _.forEach(this.$scope.accordions, (acc: DetailsAccordion) => {
                if (_.size(acc.items) > 0) {
                    _.forEach(acc.items, (item: DetailsAccordionSection) => {
                        if (item.name == accordionName) {
                            collapsed = !item.selected
                            return
                        }
                    })
                }
            })
        }

        return collapsed
    }


    //#region Events

    protected onInitialize(options: DetailsOptions): void { }

    protected onHidden(): void {
        if (this.detailsResultCallback != null) {
            this.detailsResultCallback({
                status: this.detailResultStatus,
            });
        }
    }

    //#endregion

    //#region Setup

    protected _setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this._moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => {
                this._open(args);
            }
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this._moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => {
                this.hidePopup();
            }
        )
    }

    private _open(args: any[]): void {
        this.detailResultStatus = DetailsResult.Status.Closed;

        if (_.size(args) > 2) {
            this.detailsResultCallback = args[4];
            this.onInitialize(args[3])

        }
    }

    //#endregion

    //#region Result

    protected markAsDeleted(): void {
        this.detailResultStatus = DetailsResult.Status.Deleted;
    }

    protected markAsEdited(): void {
        this.detailResultStatus = DetailsResult.Status.Edited;
    }

    //#endregion
}